module.exports = __webpack_public_path__ + "static/media/concepts_opac.9c1acd83.png";